import {
  IAgProdSaleData,
  IAggregateSaleDataParams,
  IAggregateSaleContrastData,
  ISaleRank,
  IAggregateSaleTrendParams,
  IAggregateSaleTrend,
  IAggregateSaleCount
} from './type';
import hyRequest from '@/service';

enum DashboardApi {
  getProdCmSaleVlBar = '/product/prodCmSaleVlBar',
  getAggregateSaleContrastData = '/saleData/mortarSaleContrastData',
  getAggregateSaleRank = '/saleData/mortarSaleRank',
  getAggregateSaleTrend = '/saleData/mortarSaleTrend',
  getAggregateSaleCount = '/saleData/customerAnalysisData'
}

// 产销库存柱状图
export function getProdCmSaleVlBar(data: IAggregateSaleDataParams) {
  return hyRequest.post<IAgProdSaleData>({
    url: DashboardApi.getProdCmSaleVlBar,
    data
  });
}

//骨料销售对比数据
export function getAggregateSaleContrastData(data: IAggregateSaleDataParams) {
  return hyRequest.post<IAggregateSaleContrastData>({
    url: DashboardApi.getAggregateSaleContrastData,
    data
  });
}
//骨料销售客户金额日排行榜
export function getAggregateSaleRank(data: IAggregateSaleDataParams) {
  return hyRequest.post<ISaleRank>({
    url: DashboardApi.getAggregateSaleRank,
    data: data
  });
}

//骨料销售趋势数据
export function getAggregateSaleTrend(data: IAggregateSaleTrendParams) {
  return hyRequest.post<IAggregateSaleTrend>({
    url: DashboardApi.getAggregateSaleTrend,
    data: data
  });
}

// 客户经营分析
export function getAggregateSaleCount(data: IAggregateSaleDataParams) {
  return hyRequest.post<{ list: IAggregateSaleCount[] }>({
    url: DashboardApi.getAggregateSaleCount,
    data: data
  });
}
